var adatetimeintes =  setInterval(function(){
var timeZonea = "Australia/Queensland";
var todaya = new Date(),
mmm = todaya.getMonth(),
yyyyy = todaya.getFullYear();
const months = todaya.toLocaleString('default', { month: 'short' });

var nowTimeZone2s = todaya.toLocaleString("en-AU", {timeZonea: "Australia/Queensland"});
var spls  =  nowTimeZone2s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
var splitss = spls.split("-");

var dds = splitss[0];

var TimerEndDates = months+" "+dds+" "+yyyyy;

var startTime = new Date(mmm + '/' + dds + '/' + yyyyy);
  /* set end time */
  var endHours = 23;
var endMinutess = 59;
var endSecondss = 00;

var hrsn = splitss[3];
var minssn = splitss[4];
var totaln = hrsn+''+minssn;


//for starting time for timer
//bydefault set to Australia current time
var nowDates = new Date();

var nowTimeZones = convertTZ(nowDates, timeZonea);

var nowd = new Date(nowTimeZones.getFullYear(),nowTimeZones.getMonth(),nowTimeZones.getDate());
nowd.setHours(nowTimeZones.getHours(), nowTimeZones.getMinutes(), nowTimeZones.getSeconds());

var endDated = new Date(TimerEndDates+" "+endHours+":"+endMinutess+":"+endSecondss);
// console.log(endDated);
var endDateTimed = convertTZ(endDated, timeZonea);
// console.log('end'+TimerEndDates+''+timeZonea);
var futures = new Date(endDateTimed.getFullYear(),endDateTimed.getMonth(),endDateTimed.getDate());
futures.setHours(endHours, endMinutess, endSecondss);

var differenced = Math.floor((futures - nowd) / 1000);

var secondsd = fixIntegers(differenced % 60);
differenced = Math.floor(differenced / 60);

var minutesd = fixIntegers(differenced % 60);
differenced = Math.floor(differenced / 60);

var hoursd = fixIntegers(differenced % 24);
differenced = Math.floor(differenced / 24);

// console.log('endDate'+endDate +'nowDate'+nowDate);
var daysd = differenced;
$("#secondsd").text(secondsd + "S");
$("#minutesd").text(minutesd + "M");
$("#hoursd").text(hoursd + "H");
var daysd = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
var currentdays = daysd[new Date().getDay()];

if(hoursd ==0 && minutesd == 0 && secondsd == 0){

$('.cstm_count_downtimer1').removeClass('active');
clearInterval(adatetimeintes);
}else if(currentdays =='Saturday' || currentdays =='Sunday'){
$('.cstm_count_downtimer1').removeClass('active');

}else{

// $('.cstm_count_downtimer1').removeClass('active');
}




// console.log(Intl.DateTimeFormat().resolvedOptions().timeZone);

}, 1000);
function convertTZ(date, tzString) {
var tzone = "Australia/Queensland";
return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzone}));
}
  
function fixIntegers(integer)
{
if (integer < 0)
integer = 0;
if (integer < 10)
return "0" + integer;
return "" + integer;
}